import React from "react";
import { useSelector } from "react-redux";
import { usePortalModal } from "common/effects";
import ActionLink from "components/ActionLink";
import ScenarioToolModal from "./ScenarioToolModal";

const ScenarioToolLink = ({ farm, analysisId }) => {
    const online = useSelector((state) => state.app.online);
    const { openModal, getModal } = usePortalModal();

    const launchScenarioTool = () => {
        const viewModel = { farm, analysisId };
        openModal("ScenarioToolModal", viewModel);
    };

    const scenarioToolModal = getModal("ScenarioToolModal", ScenarioToolModal);

    return (
        <>
            {online && (
                <ActionLink id="scenario-tool" className="IconLink--wand u-font-green" onClick={launchScenarioTool}>
                    Scenario tool
                </ActionLink>
            )}
            {scenarioToolModal}
        </>
    );
};

export default ScenarioToolLink;
